import { isDayOfTheWeek, isMonthOfTheYear } from './is-compare-all-time'
import SummaryType from 'scoreboard/datasets/model/summary-type'
const {
	DAY_OF_THE_WEEK,
	MONTH_OF_THE_YEAR,
	SIMILAR_TIME_RANGES
} = SummaryType

/**
 * Based on the groupCalendarId and breakdownCalendarId, updates the
 * table and settingsModel appropriately
 * @param {SettingsModel} options.settingsModel
 * @param {DatasetTable} options.table
 * @param {String} options.summaryType
 * @param {Number|String} options.groupCalendarId
 * @param {Number|String} options.breakdownCalendarId
 */
function updateSimilarTimeRanges(options) {
	let { settingsModel, table, groupCalendarId, breakdownCalendarId } = options

	let update = { groupCalendarId: null, breakdownCalendarId: null }
	let summaryType = SIMILAR_TIME_RANGES
	if (isDayOfTheWeek(options)) {
		summaryType = DAY_OF_THE_WEEK
	} else if (isMonthOfTheYear(options)) {
		summaryType = MONTH_OF_THE_YEAR
	} else {
		update.groupCalendarId = groupCalendarId
		update.breakdownCalendarId = breakdownCalendarId
	}
	settingsModel.set('summaryType', SIMILAR_TIME_RANGES)
	update.summaryType = summaryType
	table.set(update)
}

export default updateSimilarTimeRanges

updateSimilarTimeRanges.__filename__ = 'datasets/update-similar-time-ranges.js'
